import { doodBlockConfig } from "./dood-block-config";
import type { IBlockDescriptor } from "./descriptor";

export type CheckDetailsPreviewItem = {
  id: string;
  name: string;
  price: number;
  description: string;
  selected_by: {
    user: string;
    transaction: string;
  };
};

export type CheckDetailsPreviewTransaction = {
  id: string;
  amount: number;
  cancellation_reason: string;
  paid_amount: number;
  source: string;
  status: string;
  type: string;
  user: string;
  created_at: string;
  confirmed_at: string | null;
  payment_intent_id: string;
  items: readonly string[];
  tip?: {
    amount: number;
  };
};

export type CheckDetailsPreviewCheck = {
  id: string;
  closed_at: string;
  opened_at: string;
  items: readonly CheckDetailsPreviewItem[];
  transactions: readonly CheckDetailsPreviewTransaction[];
  shop: {
    id: string;
    name: string;
    current_user_roles: readonly unknown[];
  };
  marketplace: {
    id: string;
    name: string;
    current_user_roles: readonly unknown[];
  };
  onsite_location: {
    id: string;
    name: string;
  };
  final_price: number;
  active_transaction?: CheckDetailsPreviewTransaction;
  outstanding_amount: number;
  available_payment_methods: readonly {
    valid: boolean;
    violations: readonly unknown[];
    payment_method: {
      handle: string;
      position: number;
    };
  }[];
  currency: string;
};

/** Serializable preview VM for `CheckDetailsBlockComponent`. */
export type CheckDetailsBlockScenarioContent = {
  check: CheckDetailsPreviewCheck | null;
};
const {
  checkDetailsBlockDescriptor: _generatedCheckDetailsBlockDescriptor,
  checkDetailsBlockBlocDefinition,
  checkDetailsBlockDashboardLayout,
  checkDetailsBlockConfig,
  checkDetailsBlockResolveConfig,
  checkDetailsBlockProperties,
  checkDetailsBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    id: "check-details-block",
    name: "Check - Details",
    componentType: "CheckDetailsBlockComponent",
    category: "content",
    description: "Open check details displayed in the pay-at-table flow.",
    keywords: ["check", "details", "pay-at-table"],
    allowedIn: [
      { bloc: 'CheckDetailsPageComponent', slot: '*' },
    ],


    sharedFields: {},
  },
  () => ({}),
  () => 'displayAll'
);

export function checkDetailsBlockDescriptor(): IBlockDescriptor {
  return _generatedCheckDetailsBlockDescriptor;
}

export {
  checkDetailsBlockBlocDefinition,
  checkDetailsBlockDashboardLayout,
  checkDetailsBlockConfig,
  checkDetailsBlockResolveConfig,
  checkDetailsBlockProperties,
  checkDetailsBlockDefinitionSetupScenarios,
};

export type CheckDetailsBlockConfig = typeof checkDetailsBlockConfig;
